var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortaOk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_190_11",
    "data-name": "Componente 190 \\u2013 11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.982,
    height: 50.546,
    viewBox: "0 0 34.982 50.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_23057",
    "data-name": "Ret\\xE2ngulo 23057",
    fill: "#fff",
    stroke: "#40a631",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.982,
    height: 50.546,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 33.482,
    height: 49.046,
    rx: 0.25,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_521",
    "data-name": "Elipse 521",
    transform: "translate(22.803 27.421) rotate(-85)",
    fill: "#fff",
    stroke: "#40a631",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.795,
    cy: 2.795,
    rx: 2.795,
    ry: 2.795,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.795,
    cy: 2.795,
    rx: 2.045,
    ry: 2.045,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortaOk);
export default __webpack_public_path__ + "static/media/portaOK.26a555c6923f0c174fbfd5f01381e875.svg";
export { ForwardRef as ReactComponent };